/**
* This file was automatically generated by @cosmwasm/ts-codegen@1.12.1.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

import { Coin } from "@cosmjs/amino";
import { MsgExecuteContractEncodeObject } from "@cosmjs/cosmwasm-stargate";
import { MsgExecuteContract } from "cosmjs-types/cosmwasm/wasm/v1/tx";
import { toUtf8 } from "@cosmjs/encoding";
import { Uint128, InstantiateMsg, ExecuteMsg, ProposalStatus, Outcome, Proposal, Tally, QueryMsg, MarketStatus, ClaimResponse, MarketResponse, Uint256, PoolsResponse, OutcomeAccum, PositionResponse, MarketsResponse } from "./Madvotes.types";
export interface MadvotesMsg {
  contractAddress: string;
  sender: string;
  registerMarket: ({
    proposal,
    proposalId
  }: {
    proposal: Proposal;
    proposalId: number;
  }, funds_?: Coin[]) => MsgExecuteContractEncodeObject;
  placeBet: ({
    outcome,
    proposalId
  }: {
    outcome: Outcome;
    proposalId: number;
  }, funds_?: Coin[]) => MsgExecuteContractEncodeObject;
  settleMarket: ({
    proposal,
    proposalId
  }: {
    proposal: Proposal;
    proposalId: number;
  }, funds_?: Coin[]) => MsgExecuteContractEncodeObject;
  claim: ({
    proposalId
  }: {
    proposalId: number;
  }, funds_?: Coin[]) => MsgExecuteContractEncodeObject;
}
export class MadvotesMsgComposer implements MadvotesMsg {
  sender: string;
  contractAddress: string;
  constructor(sender: string, contractAddress: string) {
    this.sender = sender;
    this.contractAddress = contractAddress;
    this.registerMarket = this.registerMarket.bind(this);
    this.placeBet = this.placeBet.bind(this);
    this.settleMarket = this.settleMarket.bind(this);
    this.claim = this.claim.bind(this);
  }
  registerMarket = ({
    proposal,
    proposalId
  }: {
    proposal: Proposal;
    proposalId: number;
  }, funds_?: Coin[]): MsgExecuteContractEncodeObject => {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: MsgExecuteContract.fromPartial({
        sender: this.sender,
        contract: this.contractAddress,
        msg: toUtf8(JSON.stringify({
          register_market: {
            proposal,
            proposal_id: proposalId
          }
        })),
        funds: funds_
      })
    };
  };
  placeBet = ({
    outcome,
    proposalId
  }: {
    outcome: Outcome;
    proposalId: number;
  }, funds_?: Coin[]): MsgExecuteContractEncodeObject => {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: MsgExecuteContract.fromPartial({
        sender: this.sender,
        contract: this.contractAddress,
        msg: toUtf8(JSON.stringify({
          place_bet: {
            outcome,
            proposal_id: proposalId
          }
        })),
        funds: funds_
      })
    };
  };
  settleMarket = ({
    proposal,
    proposalId
  }: {
    proposal: Proposal;
    proposalId: number;
  }, funds_?: Coin[]): MsgExecuteContractEncodeObject => {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: MsgExecuteContract.fromPartial({
        sender: this.sender,
        contract: this.contractAddress,
        msg: toUtf8(JSON.stringify({
          settle_market: {
            proposal,
            proposal_id: proposalId
          }
        })),
        funds: funds_
      })
    };
  };
  claim = ({
    proposalId
  }: {
    proposalId: number;
  }, funds_?: Coin[]): MsgExecuteContractEncodeObject => {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: MsgExecuteContract.fromPartial({
        sender: this.sender,
        contract: this.contractAddress,
        msg: toUtf8(JSON.stringify({
          claim: {
            proposal_id: proposalId
          }
        })),
        funds: funds_
      })
    };
  };
}